export const ACCEPTED = 'ALLOWED';
export const DENIED = 'DENIED';
export const PENDING = 'PENDING';
